import { useSearchParams } from 'react-router-dom';
import { useMonitoringGoods } from './MonitoringContext';
import { Dialog, DialogTrigger } from '@/components/atoms/Dialog';
import { Button } from '@/components/atoms/PcButton';
import RegisteredMonitoringEdit from './RegisteredMonitoringEdit';
import { useState } from 'react';
import { MOCK_GOODS } from './_mock/mockGoods';
import { useMembershipMonitoringPreviewTutorial } from '@/components/membership/MembershipMonitoringPreviewTutorial';

const GoodsDetailAddKeyword = ({ isMockGoods }: { isMockGoods: boolean }) => {
  const [searchParams] = useSearchParams();
  const goodsNo = searchParams.get('select');
  const [dialogOpen, setDialogOpen] = useState(false);
  const { goods } = useMonitoringGoods();
  const { openTutorial } = useMembershipMonitoringPreviewTutorial();

  const selectedGoods =
    goods.find((item) => String(item.GoodsNo) === String(goodsNo)) ||
    MOCK_GOODS.find((item) => String(item.GoodsNo) === String(goodsNo));

  if (!selectedGoods) return null;

  return (
    <Dialog open={dialogOpen} onOpenChange={setDialogOpen}>
      <DialogTrigger asChild>
        <Button
          variant="default"
          className="h-[34px] px-[10px] py-[6px]"
          onClick={(event) => {
            if (openTutorial('addKeyword')) {
              event.preventDefault();
            }
          }}
        >
          + 키워드 추가
        </Button>
      </DialogTrigger>
      <RegisteredMonitoringEdit
        goods={selectedGoods}
        dialogOpen={dialogOpen}
        setDialogOpen={setDialogOpen}
        isMockGoods={isMockGoods}
      />
    </Dialog>
  );
};

export default GoodsDetailAddKeyword;
